export function showPrompt(e: BeforeUnloadEvent) {
  // For shortboarding allow the user to close the tab showing
  // offer-tracking without getting prompted to continue
  if (location.href.includes('/offer-tracking')) {
    return;
  }

  // Cancel the event
  e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
  // Chrome requires returnValue to be set
  e.returnValue = '';
}
